import { styled } from 'src/styles/stitches.config'

export default styled('div', {
    position: 'relative',
})
